(() => {
  const cartUrl = document.currentScript?.dataset.cartUrl;
  const sync = (count) => {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-cart-count]').forEach((badge) => { badge.textContent = count; });
    document.querySelectorAll('[data-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', String(count)));
    });
  };
  document.addEventListener('ethnicwish:cart-change', (event) => sync(event.detail?.item_count));
  window.addEventListener('pageshow', async (event) => {
    if (!event.persisted || !cartUrl) return;
    try {
      const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
      if (response.ok) sync((await response.json()).item_count);
    } catch (_) {}
  });
})();
